import { Box, Chip, Grid, Typography } from '@material-ui/core';
import { moneyFormat } from 'design-system';
// Functions
import getMonthlyPrice from 'src/functions/getMonthlyPrice';
import {
  getChipPlanByOption,
  getOptionName,
} from 'src/functions/individualOptionHelpers';

const { formatMoney } = moneyFormat;

type Props = {
  anualPrice: number;
  moneyType: string | undefined;
  packageOption: number;
  profileType?: string;
  openDialog?: boolean;
  isInspection?: boolean;
  createdAt?: string;
};

const IndividualPriceDetail = ({
  anualPrice,
  moneyType,
  packageOption,
  profileType,
  openDialog,
  isInspection,
  createdAt,
}: Props): JSX.Element => {
  const chipPlan = getChipPlanByOption(packageOption);
  return (
    <>
      <Grid
        item
        container
        justifyContent="center"
        style={{ marginBottom: openDialog ? '0.5rem' : '0px' }}
      >
        <Typography variant="h2">
          {getOptionName(packageOption, createdAt)}
        </Typography>
      </Grid>
      <Grid item container justifyContent="center">
        <Chip
          label={
            <Typography
              data-testid="price-option-description"
              variant="caption"
              style={{ fontSize: 15, color: chipPlan.colorText }}
            >
              {chipPlan.title}
            </Typography>
          }
          style={{ backgroundColor: chipPlan.colorBackground }}
        />
      </Grid>
      <Grid
        item
        container
        spacing={2}
        justifyContent="space-between"
        alignItems="center"
        style={
          openDialog || isInspection
            ? { paddingTop: '0.8rem', flexDirection: 'row' }
            : { paddingTop: '0.5rem', flexDirection: 'column' }
        }
      >
        <Grid
          item
          style={{
            textAlign: openDialog || isInspection ? 'left' : 'center',
          }}
        >
          <Typography
            style={{
              fontSize: openDialog || isInspection ? 23 : 27,
              fontWeight: openDialog || isInspection ? 700 : 900,
            }}
          >
            {formatMoney(getMonthlyPrice(anualPrice), true, moneyType)}
          </Typography>
          <Typography
            style={{
              fontSize: openDialog || isInspection ? 12 : 15,
              fontWeight: openDialog || isInspection ? 400 : 700,
            }}
          >
            12 cuotas mensuales
          </Typography>
        </Grid>
        {!openDialog && !isInspection && (
          <hr
            style={{
              width: '100%',
              borderTop: 'dashed 1px #0D2E68',
              borderBottom: 'none',
            }}
          />
        )}
        <Box
          display="flex"
          alignItems="center"
          style={
            openDialog || isInspection
              ? {
                  gap: '0',
                  flexDirection: 'column-reverse',
                  padding: '8px',
                  alignItems: 'flex-end',
                }
              : {
                  gap: '10px',
                  flexDirection: 'row',
                  padding: '8px',
                  alignItems: 'center',
                }
          }
        >
          <Typography
            style={
              openDialog || isInspection
                ? {
                    fontSize: 12,
                    fontWeight: 400,
                  }
                : {
                    fontSize: 15,
                    fontWeight: 500,
                  }
            }
            align={openDialog ? 'right' : 'center'}
          >
            Total anual{openDialog || isInspection ? '' : ':'}
          </Typography>
          <Typography
            style={
              openDialog
                ? {
                    fontSize: 23,
                    fontWeight: 700,
                  }
                : {
                    fontSize: 19,
                    fontWeight: 700,
                  }
            }
            align={openDialog ? 'right' : 'center'}
          >
            {formatMoney(anualPrice, true, moneyType)}
          </Typography>
        </Box>
      </Grid>
      {profileType === 'retencion' && (
        <Grid item container justifyContent="center">
          <Typography
            data-testid="price-option-description"
            variant="caption"
            style={{
              fontFamily: 'Roboto',
              fontSize: 14,
              fontWeight: 400,
              marginTop: 10,
            }}
          >
            *Primer mes gratis.
          </Typography>
        </Grid>
      )}
    </>
  );
};

export default IndividualPriceDetail;
